/**
 * Cihaz Tanımlayıcısı Oluşturma ve Yönetme Modülü
 * Her cihaz için benzersiz bir ID oluşturur ve localStorage'da saklar
 */

// UUID v4 oluştur
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

// Tarayıcı fingerprint'i oluştur (yedek tanımlayıcı)
const getBrowserFingerprint = () => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillText('Browser Fingerprint', 2, 2);

  const fingerprint = [
    navigator.userAgent,
    navigator.language,
    window.screen.width,
    window.screen.height,
    window.screen.colorDepth,
    new Date().getTimezoneOffset(),
    !!window.sessionStorage,
    !!window.localStorage,
    canvas.toDataURL()
  ].join('|');

  // Basit hash fonksiyonu
  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // 32-bit integer'a dönüştür
  }

  return Math.abs(hash).toString(36);
};

// Bilgisayar adını otomatik oluştur (friendly name)
const generateComputerName = () => {
  const platform = navigator.platform || 'Unknown';
  const browser = (() => {
    const ua = navigator.userAgent;
    if (ua.includes('Chrome')) return 'Chrome';
    if (ua.includes('Firefox')) return 'Firefox';
    if (ua.includes('Safari')) return 'Safari';
    if (ua.includes('Edge')) return 'Edge';
    return 'Browser';
  })();

  const timestamp = Date.now().toString(36).slice(-4).toUpperCase();
  return `${platform}-${browser}-${timestamp}`;
};

/**
 * Cihaz ID'sini al veya oluştur
 * @returns {string} Benzersiz cihaz ID'si
 */
export const getDeviceId = () => {
  const STORAGE_KEY = 'device_id';
  const STORAGE_KEY_COMPUTER_NAME = 'computer_name';

  try {
    // Mevcut device ID'yi kontrol et
    let deviceId = localStorage.getItem(STORAGE_KEY);

    if (!deviceId) {
      // Yeni device ID oluştur
      deviceId = generateUUID();
      localStorage.setItem(STORAGE_KEY, deviceId);
      // console.log('✅ Yeni cihaz ID oluşturuldu:', deviceId);
    }

    return deviceId;
  } catch (error) {
    // localStorage erişimi engellenmiş olabilir
    console.warn('⚠️ localStorage erişimi engellendi, fingerprint kullanılıyor');
    return getBrowserFingerprint();
  }
};

/**
 * Bilgisayar adını al veya oluştur
 * @returns {string} Bilgisayar/Cihaz adı
 */
export const getComputerName = () => {
  const STORAGE_KEY = 'computer_name';

  try {
    let computerName = localStorage.getItem(STORAGE_KEY);

    if (!computerName) {
      computerName = generateComputerName();
      localStorage.setItem(STORAGE_KEY, computerName);
      // console.log('✅ Yeni bilgisayar adı oluşturuldu:', computerName);
    }

    return computerName;
  } catch (error) {
    return generateComputerName();
  }
};

/**
 * Cihaz ID'sini sıfırla (debug için)
 */
export const resetDeviceId = () => {
  try {
    localStorage.removeItem('device_id');
    localStorage.removeItem('computer_name');
    console.log('✅ Cihaz ID sıfırlandı');
  } catch (error) {
    console.error('❌ Cihaz ID sıfırlanamadı:', error);
  }
};

/**
 * Cihaz bilgilerini getir
 * @returns {object} Cihaz bilgileri
 */
export const getDeviceInfo = () => {
  return {
    deviceId: getDeviceId(),
    computerName: getComputerName(),
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timestamp: new Date().toISOString()
  };
};

// Debug için global fonksiyon
if (typeof window !== 'undefined') {
  window.showDeviceInfo = () => {
    const info = getDeviceInfo();
    console.table(info);
    return info;
  };

  window.resetDeviceId = resetDeviceId;
}

export default {
  getDeviceId,
  getComputerName,
  resetDeviceId,
  getDeviceInfo
};
